import React, { useEffect, useState } from "react";
import BodyWrapper from "../../../components/Wrapper/BodyWrapper";
import Header from "../../../components/Header/Header";
import CustomBtn from "../../../components/Buttons/CustomBtn";
import AddBranchModal from "../../../components/Modals/AddBranchModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchBranches } from "../../../store/Slices/BranchesSlice";
import SearchableTable from "../../../components/Tables/SearchableTable";
import { BranchColumns } from "../../../assets/Columns/BranchColumns";

const Branches = () => {
  const [OpenEditModal, setOpenEditModal] = useState(false);
  const [OpenDeleteModal, setOpenDeleteModal] = useState(false);
  const [Selected, setSelected] = useState("");
  const [Loading, setLoading] = useState(false);
  const [SearchText, setSearchText] = useState("");

  const [OpenModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const BranchesState = useSelector((state) => state.Branches);

  useEffect(() => {
    dispatch(fetchBranches());
  }, [dispatch]);
  return (
    <BodyWrapper>
      <Header title="Branches" desc="Overview of your branch management">
        <CustomBtn
          title={"Add New Branch"}
          onClick={() => {
            setOpenModal(true);
          }}
        />
      </Header>

      <div className="w-full max-w-7xl">
        <SearchableTable
          setOpenEditModal={setOpenEditModal}
          setOpenDeleteModal={setOpenDeleteModal}
          setSelected={setSelected}
          SearchPlaceholder={"Search Branch Name..."}
          SearchText={SearchText}
          setSearchText={setSearchText}
          CurrentData={BranchesState.data}
          Columns={BranchColumns}
        />
      </div>
      {OpenModal && <AddBranchModal Open={OpenModal} setOpen={setOpenModal} />}
    </BodyWrapper>
  );
};

export default Branches;
